import React from 'react';
import { Select } from '@chakra-ui/react';
import Table from '../../../shared/table/Table';

const STATUS_BADGE = {
  pending: { colorScheme: 'orange', label: 'بانتظار التواصل' },
  contacted: { colorScheme: 'blue', label: 'تم التواصل' },
  completed: { colorScheme: 'green', label: 'مكتمل' },
  rejected: { colorScheme: 'red', label: 'مرفوض' },
};

const ShopItemOffersTable = ({ data, page, handleUpdateStatus }) => (
  <Table>
    <thead>
      <tr>
        <th>#</th>
        <th>العنصر المطلوب</th>
        <th>السعر المطلوب</th>
        <th>مقدّم العرض</th>
        <th>ديسكورد صاحب الطلب</th>
        <th>السعر المعروض</th>
        <th>الحالة</th>
      </tr>
    </thead>
    <tbody>
      {data?.map((offer, idx) => (
        <tr key={offer._id}>
          <td>{(page - 1) * 10 + idx + 1}</td>
          <td>{offer.item?.name}</td>
          <td>{offer.item?.price_num}</td>
          <td>{offer.offered_by?.name}</td>
          <td>{offer.item?.contact_discord}</td>
          <td>{offer.offer_price ?? 'نفس السعر'}</td>
          <td>
            <Select
              size="sm"
              width="160px"
              value={offer.status}
              onChange={(e) => handleUpdateStatus(offer, e.target.value)}
            >
              {Object.entries(STATUS_BADGE).map(([key, meta]) => (
                <option key={key} value={key}>{meta.label}</option>
              ))}
            </Select>
          </td>
        </tr>
      ))}
    </tbody>
  </Table>
);

export default ShopItemOffersTable;
